import { useCallback, useMemo } from 'react';

import type { GridPaginationModel } from '@packages/fenrir/components/datagrid';

import type { UsePaginationOptions } from '../use-pagination/use-pagination';
import { usePagination } from '../use-pagination/use-pagination';

// TODO @deceptions S2CX-12075: Move to fenrir package
export const useGridPaginationModel = (options?: UsePaginationOptions) => {
  const [pagination, setPage, setPageSize] = usePagination(options);

  const paginationModel = useMemo(
    () => ({
      page: pagination.pageIndex,
      pageSize: pagination.pageSize,
    }),
    [pagination.pageIndex, pagination.pageSize],
  );

  const setPaginationModel = useCallback(
    ({ page, pageSize }: Partial<GridPaginationModel>) => {
      if (pageSize !== undefined && pageSize !== paginationModel.pageSize) {
        setPageSize(pageSize);
        return;
      }

      if (page !== undefined) setPage(page);
    },
    [paginationModel.pageSize, setPage, setPageSize],
  );

  return {
    paginationModel,
    setPaginationModel,
  };
};
